import { useEffect, useState } from 'react'
import { useMap, useMapEvents } from 'react-leaflet'
import 'leaflet-control-geocoder/dist/Control.Geocoder.css'
import 'leaflet-control-geocoder/dist/Control.Geocoder.js'
import L from 'leaflet'

import { WeatherInfo } from './EpwMap.types'
import { Button, Logo } from '../atoms'
import { Label } from '@radix-ui/react-dropdown-menu'
import React from 'react'
import Icon from '@ant-design/icons'
import toast from 'react-hot-toast'
import { Download, Clipboard, Send, Table } from 'react-bootstrap-icons'

import { LeafletCustomPopup } from './LeafletCustomPopup'

// download 
const download = (url: string) => {
  const a = document.createElement('a')
  document.body.appendChild(a)
  a.style.display = 'none'
  a.id = 'download'
  
  a.href = url
  a.target = '_blank'
  a.click()
  document.body.removeChild(a)
}

/**
 * Search widget
 */
export const LeafletControlGeocoder = ({}) => {
  const map = useMap()
  
  useEffect(() => {
    var geocoder = L.Control.Geocoder.nominatim()
    if (typeof URLSearchParams !== 'undefined' && location.search) {
      var params = new URLSearchParams(location.search)
      var geocoderString = params.get('geocoder')
      if (geocoderString && L.Control.Geocoder[geocoderString]) {
        geocoder = L.Control.Geocoder[geocoderString]()
      } else if (geocoderString) {
        console.warn('Unsupported geocoder', geocoderString)
      }
    }

    L.Control.geocoder({
      query: '',
      placeholder: 'Search...',
      defaultMarkGeocode: false,
      geocoder
    })
      .on('markgeocode', (e) => {
        const latlng = e.geocode.center
        const marker = L.circleMarker(latlng, {
          color: '#eb2126',
          radius: 8,
        })
          .addTo(map)
          .bindPopup(e.geocode.name)
          .openPopup()
        map.fitBounds(e.geocode.bbox)

        // Remove marker on close
        marker.getPopup()
          .on('remove', () => {
            marker.remove()
        })
      })
      .addTo(map)
  }, [])

  return null
}

/**
 * Points layer with popup widget
 * it uses a performance issue workaround
 */
export const LeafletMultiplePoints = ({ data, onCopy, enableCopyToClipboard }) => {
  const map = useMap()

  const [feature, setFeature] = useState<WeatherInfo>(undefined)

  const reset = () => {
    setFeature(undefined)
  }

  useEffect(() => {
    var myRenderer = L.canvas({ padding: 0.5 })

    data.forEach((d) => {
      L.circleMarker([d.lat, d.lon], {
        renderer: myRenderer,
        color: d.color,
        radius: 3,
      })
      .on('click', () => setFeature(d))
      .addTo(map)
    })

    return setFeature(undefined)
  }, [])


  const getToast = (msg: string) => {
    return toast.success(msg, {
      duration: 2000,
      position: 'bottom-left',
      style: { fontSize: '14px' },
      iconTheme: {
        primary: '#000',
        secondary: '#fff',
      },
      ariaProps: {
        role: 'alert',
        'aria-live': 'assertive',
      },
    })
  }


  return (feature ? <LeafletCustomPopup coordinates={[feature.lat, feature.lon]} map={map} onClose={reset}>
    <div key={feature.link}>
      <table className='epw-map-popup-title'>
        <td>
          <tr>
            <td>{feature.station}</td>
          </tr>
          <tr>
            <td>{feature.id}</td>
          </tr>
          <tr>
            <td>{feature.source}</td>
          </tr>
        </td>
      </table>
      {/* <Label
        className='epw-map-popup-title'>
        {feature.station}::{feature.id}::{feature.source}
      </Label> */}
        <Button
          style={{ 
            width: '100%',
            margin: '4px 0'
          }}
          onClick={() => download(feature.link)}>
          <Icon component={Download} />
          Download
        </Button>
        {enableCopyToClipboard && <Button
          onClick={() => {
            // https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/writeText#browser_compatibility
            navigator.clipboard.writeText(feature.link)
            .then(() => getToast('Copied to Clipboard'))
          }}
          style={{ 
            width: '100%',
            margin: '4px 0'
          }}>
          <Icon component={Clipboard}/>
          Copy
        </Button>}
        {onCopy && <Button
          onClick={() => {
            onCopy(feature)
            getToast('Just sent!')
          }}
          style={{ 
            width: '100%' 
          }}>
          <Icon component={Send}/>
          Send to browser
        </Button>}
    </div>
  </LeafletCustomPopup> : <></>)
}

/**
 * Location center widget
 */
export const LocationTracker = ({ center, widgetStyle }) => {
  const [position, setPosition] = useState(center)
  
  const map = useMapEvents({
    move() {
      const center = map.getCenter()
      setPosition(center)
    },
  })

  // Update view init state
  useEffect(() => {
    map.setView(center)
  }, [center])

  return position === null ? null : (
    <div className='epw-general-widget epw-map-sidebar' style={{ ...widgetStyle }}>
    <span style={{ float: 'left', padding: '2px', margin: '0 8px 0 0' }}>
      <Logo size={20}/>
    </span>{position.lat.toFixed(5)} | {position.lng.toFixed(5)}</div> 
  )
}